export default new Map([
    ['read_miniapp_slug', 'Permite ver o slug do eitri-app'],
    ['read_miniapp_credential', 'Permite ver as credenciais do eitri-app'],
    ['read_userminiapp', 'Permite ler as actions'],
    ['read_category', 'Permite ler a categoria'],
    ['write_category', 'Permite criar uma categoria'],
    ['write_miniapp', 'Permitir criar um eitri-app'],
    ['write_miniapp_user', 'Permite editar um desenvolvedor'],
    ['write_miniapp_revision', 'Permite criar uma revisão para o eitri-app'],
    ['write_miniapp_credential', 'Permite criar as credenciais (ClientId e ClientSecret) para o eitri-app'],
    ['write_invite', 'Permite convidar alguém para o eitri-app'],
    ['write_userminiapp', 'Permite associar o usuario a um eitri-app'],
    ['reject_revision', 'Permite rejeitar a revisão'],
    ['develop_miniapp', 'Permite desenvolver um eitri-app'],
    ['download_sources', 'Permite que o membro de um mini-app tenha acesso aos codigos fonte desse mini-app.'],
    ['manage_miniapp_devs', 'Permite gerenciar desenvolvedores de um eitri-app'],
])
